import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Mi hijo dejó de pedir galletas a las 4 de la tarde. No lo puedo creer. Seguí el Menú Blindado al pie de la letra y en 10 días el cambio fue brutal. Duerme mejor, se concentra más en la tarea y los berrinches de la noche prácticamente desaparecieron.',
  name: 'Carolina M.',
  detail: 'Mamá de Sebastián, 6 años',
  stars: 5
}, {
  quote: "Yo era de las que compraba todo 'light' y 'natural' pensando que hacía bien. Cuando apliqué el Escáner de 3 Segundos me di cuenta de la cantidad de azúcar escondida que les estaba dando. Ahora mis hijos comen mejor y ni se han dado cuenta del cambio.",
  name: 'Fernanda R.',
  detail: 'Mamá de Valentina (8) y Mateo (4)',
  stars: 5
}, {
  quote: 'Trabajo todo el día y no tengo tiempo de cocinar recetas complicadas. Este manual me salvó. Las preparaciones son rápidas, los ingredientes son baratos y mi hija dejó de enfermarse cada dos semanas. Lo recomiendo a todos los papás que conozco.',
  name: 'Roberto G.',
  detail: 'Papá de Lucía, 9 años',
  stars: 5
}];
function Stars({
  count
}: {
  count: number;
}) {
  return <div className="flex gap-1 mb-4 justify-center" data-id="element-172">
      {Array.from({
      length: count
    }).map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-173" />)}
    </div>;
}
export function TestimonialsSection() {
  return <section className="py-14 bg-cream" data-id="element-174">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-175">
        <FadeIn data-id="element-176">
          <div className="text-center mb-10" data-id="element-177">
            <h2 className="text-3xl md:text-4xl font-bold text-ink mb-4" data-id="element-178">
              Lo Que Dicen los Padres
            </h2>
            <p className="text-ink/60 text-lg" data-id="element-179">
              Familias reales que aplicaron el Escudo Metabólico
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-180">
          {testimonials.map((t, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-181">
              <div className="bg-white rounded-2xl p-8 shadow-sm border border-forest/5 h-full flex flex-col text-center" data-id="element-182">
                <Stars count={t.stars} data-id="element-183" />
                <blockquote className="text-ink/80 leading-relaxed flex-1 mb-6" data-id="element-184">
                  "{t.quote}"
                </blockquote>
                <div className="border-t border-ink/5 pt-5 mt-auto" data-id="element-185">
                  <p className="font-bold text-ink" data-id="element-186">{t.name}</p>
                  <p className="text-sm text-ink/50" data-id="element-187">{t.detail}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}